import { AddressPartsType } from 'components/common/AddressInputs/addressInputs.enums';
import { SelectOptionType } from 'components/common/InputSelect/inputSelect.types';
import { STATES } from 'constants/address.constants';

export interface GeoAttrs {
  streetAddress: string;
  city: string;
  state: string;
  zip: string;
  county: string;
}

export const getAddressParts = (addressComponents: google.maps.places.AddressComponent[]) => {
  return addressComponents.reduce(
    (acc, { types, longText, shortText }) => {
      if (types.includes(AddressPartsType.State) && shortText) {
        acc.state = shortText;
      }

      if (types.includes(AddressPartsType.Locality) && longText) {
        acc.city = longText;
      }

      if (types.includes(AddressPartsType.PostalCode) && shortText) {
        acc.zip = shortText;
      }

      if (types.includes(AddressPartsType.County) && shortText) {
        acc.county = shortText;
      }

      if (types.includes(AddressPartsType.StreetNumber) && longText) {
        acc.streetAddress = acc.streetAddress ? `${longText} ${acc.streetAddress}` : longText;
      }

      if (types.includes(AddressPartsType.StreetName) && longText) {
        acc.streetAddress = acc.streetAddress ? `${acc.streetAddress} ${longText}` : longText;
      }

      return acc;
    },
    { state: '', city: '', zip: '', streetAddress: '' } as GeoAttrs,
  );
};

export const getStateOptions = (): SelectOptionType[] => {
  return [
    ...STATES.map(({ value }) => ({
      value: value,
      label: value,
    })),
  ];
};
